import { render, staticRenderFns } from "./NavbarDesktop.vue?vue&type=template&id=efad8268&scoped=true&"
import script from "./NavbarDesktop.vue?vue&type=script&lang=js&"
export * from "./NavbarDesktop.vue?vue&type=script&lang=js&"
import style0 from "./NavbarDesktop.vue?vue&type=style&index=0&id=efad8268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efad8268",
  null
  
)

export default component.exports